import React from 'react';
import Txt from '../../../inputs/textInput.js';
import { setChangePasswordForm } from '../../../../actions/user.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { clone } from '../../../../reducers/helper.js';
var passwordValidator = require('../../../../businessLogic/resetPasswordValidation');
import { useMediaQuery } from 'react-responsive';
import { oldBreakpoints } from '../../../../mediaSetting';
import { useDispatch } from 'react-redux';

export default function CenterPanelChangePassword(props) {
  const isGreaterThanMedium = useMediaQuery({
    query: `(min-width: ${oldBreakpoints.medium}px)`,
  });
  return <CenterPanelChangePasswordComponent {...props} isGreaterThanMedium={isGreaterThanMedium} />;
}

const CenterPanelChangePasswordComponent = (props) => {
  const dispatch = useDispatch();
  let passwordValue = '';

  const changePasswordFormUpdated = (property, value) => {
    var changePassword = clone(props.changePassword);
    changePassword[property] = value;
    dispatch(setChangePasswordForm(changePassword));
    return changePassword;
  };
  const passwordChanged = (value) => {
    value = passwordValidator.removeInvalidChars(value);
    changePasswordFormUpdated('newPassword', value);
  };
  const oldPasswordChanged = (value) => {
    changePasswordFormUpdated('oldPassword', value);
  };
  const confirmPasswordChanged = (value) => {
    changePasswordFormUpdated('confirmNewPassword', value);
  };

  return (
    //fixing the alignment issue
    <div className={props.isGreaterThanMedium ? 'ui form pdlxs mrblll' : 'ui form '}>
      <div>
        <span className=" ">{APP.LANGUAGE.ResetPassword.ChangePasswordHeading}</span> <br />
        <span className="mrts bold mrbm ">{props.userEmail}</span>
        <ValidMe validmefor="required" group="changePasswordForm">
          <Txt
            tabIndex="1"
            autoComplete="new-password"
            type="password"
            focusme="true"
            value={props.changePassword.oldPassword}
            placeholder={APP.LANGUAGE.ResetPassword.OldPassword}
            titlePlaceholder={APP.LANGUAGE.ResetPassword.OldPassword}
            noTitle
            onChange={oldPasswordChanged}
          />
        </ValidMe>
        <ValidMe
          validmefor="condition"
          group="changePasswordForm"
          getTemplatedError={(value) => {
            return passwordValidator.getErrorStyles(value || props.changePassword.newPassword);
          }}
          condition={(value) => {
            //if all password strength conditions are good, returns true. else returns false.
            var np = value || props.changePassword.newPassword;
            if (
              !passwordValidator.verifyPasswordLength(np) ||
              !passwordValidator.verifyPasswordStrengthLetter(np) ||
              !passwordValidator.verifyPasswordStrengthNumber(np) ||
              !passwordValidator.verifyPasswordStrengthSpecialCharacter(np)
            )
              return false;
            passwordValue = value;
            return true;
          }}
        >
          <Txt
            tabIndex="1"
            autoComplete="new-password"
            type="password"
            value={props.changePassword.newPassword}
            placeholder={APP.LANGUAGE.ResetPassword.NewPasswordholder}
            titlePlaceholder={APP.LANGUAGE.ResetPassword.NewPasswordholder}
            noTitle
            onChange={passwordChanged}
          />
        </ValidMe>
        <ValidMe
          validmefor="condition"
          group="changePasswordForm"
          validmemessagecondition={APP.LANGUAGE.ResetPassword.ConfirmPasswordNotSame}
          condition={(value) => {
            return value == passwordValue;
          }}
        >
          <Txt
            tabIndex="1"
            autoComplete="new-password"
            type="password"
            value={props.changePassword.confirmNewPassword}
            placeholder={APP.LANGUAGE.ResetPassword.ConfirmNewPasswordholder}
            titlePlaceholder={APP.LANGUAGE.ResetPassword.ConfirmNewPasswordholder}
            noTitle
            onChange={confirmPasswordChanged}
          />
        </ValidMe>
      </div>
    </div>
  );
};
